import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowIncomeOwnerItem } from '../types/cashFlowIncomeOwner'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowIncomeOwner: builder.query<CashFlowIncomeOwnerItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeOwner/${data.id}`,
      }),
    }),
    changeCashFlowIncomeOwner: builder.mutation<void, PayloadRequest & CashFlowIncomeOwnerItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeOwner/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowIncomeOwner: builder.mutation<void, CashFlowIncomeOwnerItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeOwner/`,
        method: 'POST',
        body: data
      }),
    }),
  }),
})

export const {
  useChangeCashFlowIncomeOwnerMutation,
  useCreateCashFlowIncomeOwnerMutation,
  useGetCashFlowIncomeOwnerQuery,
  useLazyGetCashFlowIncomeOwnerQuery,
} =
cashFlowSchemas
